import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "ins_cookie_consent";

export const CookieConsent = () => {
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [analyticsOptIn, setAnalyticsOptIn] = useState(false);
  const [hasRecordedChoice, setHasRecordedChoice] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(CONSENT_KEY);
      if (!raw) {
        setVisible(true);
        setHasRecordedChoice(false);
      }
      if (raw) {
        const parsed = JSON.parse(raw);
        setAnalyticsOptIn(!!parsed.analytics);
        setHasRecordedChoice(true);
      }
    } catch {}
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ essential: true, analytics: analyticsOptIn, at: Date.now(), lang: i18n.language }));
    } catch {}
    setVisible(false);
    setHasRecordedChoice(true);
    if (analyticsOptIn) {
      const event = new CustomEvent("ins_analytics_opt_in", { detail: { enabled: true } });
      window.dispatchEvent(event);
    }
  };

  const decline = () => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ essential: true, analytics: false, at: Date.now(), lang: i18n.language }));
    } catch {}
    setVisible(false);
    setHasRecordedChoice(true);
  };

  const handleManage = () => {
    try {
      const raw = localStorage.getItem(CONSENT_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        setAnalyticsOptIn(!!parsed.analytics);
      }
    } catch {}
    setVisible(true);
  };

  return (
    <>
      {hasRecordedChoice && !visible ? (
        <button
          type="button"
          onClick={handleManage}
          className="fixed bottom-4 left-4 z-[60] rounded-full border border-white/40 bg-neutral-900/80 px-4 py-2 text-xs font-medium text-white shadow-lg backdrop-blur transition hover:bg-neutral-900"
        >
          {t("privacy.manage_cookies", { defaultValue: "Cookie preferences" })}
        </button>
      ) : null}

      {visible ? (
        <div className="fixed inset-x-0 bottom-0 z-[60]">
          <div className="container mx-auto px-4 pb-4">
            <div className="rounded-2xl bg-white shadow-lg border border-neutral-200 p-4 md:p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="text-sm text-neutral-700 md:max-w-3xl">
                {t("privacy.banner_text", {
                  defaultValue:
                    "We use essential cookies to run this site, and optional analytics if you allow it. You can change your choice later in your browser.",
                })}
              </div>
              <div className="flex flex-col md:flex-row items-start md:items-center gap-3">
                <label className="inline-flex items-center gap-2 text-sm text-neutral-700">
                  <input
                    type="checkbox"
                    className="h-4 w-4"
                    checked={analyticsOptIn}
                    onChange={(e) => setAnalyticsOptIn(e.target.checked)}
                  />
                  {t("privacy.enable_analytics", { defaultValue: "Enable analytics" })}
                </label>
                <div className="flex items-center gap-2">
                  <Button variant="outline" onClick={decline}>{t("privacy.decline", { defaultValue: "Decline" })}</Button>
                  <Button onClick={accept}>{t("privacy.accept", { defaultValue: "Accept" })}</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
